import {ErrorMessage} from 'formik'

export const PaymentMethodError = () => <ErrorMessage name='payment_method' component='span' className='help-inline' />
